var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1475_329)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 160,
    r: 160,
    fill: "white",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.178 265.485C131.893 264.227 120.961 256.079 115.739 248.761C113.223 245.235 108.842 235.881 106.344 228.704C103.679 221.044 102.541 214.936 101.992 205.347C101.333 193.844 99.6652 174.559 98.7342 167.681C98.3202 164.618 95.8692 153.481 93.2872 142.931C86.4072 114.821 86.2102 114.107 84.6502 111.573C83.6942 110.022 80.2742 106.795 74.3622 101.866C61.9922 91.551 58.0942 86.494 56.8322 79.124C55.8002 73.095 58.6762 63.809 62.7352 60.068C65.7442 57.295 67.7372 56.747 74.7502 56.77C81.7342 56.792 85.7162 57.66 91.7502 60.477C96.6972 62.786 101.511 66.376 111.5 75.198C119.25 82.043 119.25 82.042 122.576 81.772C124.405 81.624 129.4 80.832 133.674 80.014C148.795 77.12 155.279 76.902 163.906 78.993C168.931 80.211 170.038 80.231 174.612 79.191C177.155 78.612 181.533 76.657 189.96 72.338C215.11 59.447 220.122 57.262 229.13 55.26C234.601 54.044 244.112 54.375 248.053 55.919C251.931 57.439 255.202 59.676 258.885 63.323C262.725 67.127 263.5 68.865 263.5 73.681C263.5 81.997 258.279 92.532 250.744 99.418C246.747 103.07 242.887 105.455 231.998 110.99C226.634 113.717 221.712 116.443 221.06 117.051C218.372 119.556 216.868 125.233 212.732 148.5C206.366 184.309 201.4 203.601 194.261 220.25C187.268 236.558 178.097 249.117 167.684 256.644C161.931 260.803 152.545 264.476 145.745 265.23C144.098 265.412 142.188 265.638 141.5 265.731C140.812 265.824 139.318 265.713 138.178 265.485Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.986 257.852C126.947 256.029 123.02 250.921 122.609 241.75C122.161 231.777 124.927 223.452 130.327 218.517C139.841 209.821 152.926 209.966 162.549 218.875C166.131 222.191 168.206 225.985 169.031 230.721C170.932 241.636 162.716 252.523 149.39 256.75C144.666 258.248 138.737 258.702 134.986 257.852Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.379 166C166.724 163.82 163.219 160.157 162.618 152.668C161.575 139.676 173.245 123.527 182.431 125.251C189.077 126.498 193.057 132.083 195.308 143.321C196.602 149.781 196.609 149.955 195.804 153.571C194.616 158.906 192.234 163.371 189.583 165.23C187.648 166.587 186.977 166.762 183.333 166.863C180.606 166.938 177.965 166.651 175.379 166Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.179 160.05C110.613 158.625 107 153.002 107 145.762C107 134.587 115.612 127.914 124.39 132.289C129.383 134.777 131.696 138.941 131.727 145.5C131.75 150.353 130.625 153.524 127.85 156.419C124.823 159.578 120.088 161.05 116.179 160.05Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.649 99.2501C194.039 97.9701 193.494 97.5001 192.619 97.5001C191.425 97.5001 188.5 95.0491 188.5 94.0481C188.5 93.7571 189.119 93.3971 189.875 93.2481C190.631 93.0991 192.15 92.7021 193.25 92.3641C194.96 91.8401 195.272 91.5261 195.401 90.2031C195.553 88.6381 195.022 87.9091 192.005 85.5641C190.799 84.6251 190.787 84.5651 191.659 83.6011C192.363 82.8241 193.353 82.5651 196.198 82.4221C199.52 82.2541 199.98 82.0981 201.458 80.6201C203.369 78.7091 203.635 78.6721 205.584 80.0601C207.072 81.1201 207.072 81.1201 205.776 82.4731C204.48 83.8261 204.479 83.8261 205.489 84.7401C206.959 86.0711 206.737 86.7641 204.673 87.2871C201.851 88.0031 200.9 89.7151 200.495 94.8111C200.203 98.4951 199.974 99.3121 199.019 100.085C197.185 101.57 195.612 101.269 194.649 99.2501Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1475_329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 320,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogs);
export default __webpack_public_path__ + "static/media/DOGS.1e9026e359d37654be0cc70d9bdbd2c3.svg";
export { ForwardRef as ReactComponent };